<template>
  <div class="search-bar-container">
        <el-drawer class="editor-search-bar" :visible.sync="drawer" direction="ltr" :before-close="handleClose" size="650px">
          <div class="search-con">
            <el-select v-model="searchType" @change="typeChange">
              <el-option
                label="关键词"
                :value="0"/>
                <el-option
                label="词条"
                :value="1"/>
            </el-select>
            <el-input v-model="keyword" placeholder="请输入搜索内容" @keyup.enter.native="handleTabClick"></el-input>
          </div>
          <div class="tags-list" v-if="searchType">
            <el-tag effect="dark" v-for="item in tagList" :class="{active: activeTag === item.classify_id}" :key="item.classify_id" @click="handleTagClick(item)">{{ item.classify_name }}</el-tag>
          </div>
          <el-tabs class="search-bar-main" v-model="activeName" @tab-click="handleTabClick">
            <el-tab-pane v-for="(item, idx) in searchConfig" :key="idx" :label="`${item.label}(${totalList[idx]})`" :name="item.name"></el-tab-pane>
          </el-tabs>
          <List v-if="showType === 0" :activeName="activeName" @openUrl="openUrl"></List>
                     <div v-else class="search-bar-con" v-loading="loading" v-infinite-scroll="loadMore" :infinite-scroll-disabled="!hasMore">
            <p v-if="!list.length" class="empty">暂无内容</p>
            <el-collapse v-model="activeNames" @change="change" v-if="activeName !== 'draft' && activeName !== 'mindmap'">
              <el-collapse-item v-for="(item, idx) in list" :key="`${activeName}-${item.id || idx}`" :name="item.id" >
                <template slot="title">
                  <div class="item-title" :class="{ 'friend-share-item': item.isShared }">
                    <img v-if="activeName === 'paper'" class="icon-pdf" src="https://bookor-application.oss-cn-beijing.aliyuncs.com/Word-Local-hover.png"/>
                    <img v-else-if="activeName === 'article' && !item.isShared" class="icon-pdf" src="../../assets/img/article.png"/>
                    <img v-else-if="activeName === 'article' && item.isShared" class="icon-pdf wechat-share-icon" src="https://cdn-icons-png.flaticon.com/512/220/220236.png"/>
                    <img v-else-if="activeName === 'note'" class="icon-pdf" src="../../assets/img/note.png"/>
                    <img v-else-if="activeName === 'comment'" class="icon-pdf" src="../../assets/img/article_comment.png"/>
                    <img v-else class="icon-pdf" src="../../assets/img/pdf.png" />
                    
                    <div class="title-content">
                      <span class="title-text">{{ item.title }}</span>
                      <div v-if="item.isShared" class="friend-share-meta">
                        <span class="share-author">👤 {{ item.author }}</span>
                        <span class="share-time">🕐 {{ item.share_time }}</span>
                      </div>
                    </div>
                  </div>
                </template>
                <div v-for="(child, idx) in item.content_arr" :key="idx">
                  <el-tooltip class="item" effect="dark" placement="top" popper-class="more-content-tooltip">
                    <div slot="content" class="more-content">{{ child?.complete }}</div>
                    <div class="item-text" @click="handleCon(item)"  v-html="formatStr(child.current)"></div>
                  </el-tooltip>
                </div>
              </el-collapse-item>
            </el-collapse>
            <div v-else class="draft-list-con">
              <template v-if="activeName === 'draft'">
                <div class="item-title" v-for="(item, index) in list" :key="`draft-${item.id || index}`" @click="toDraft(item.id)">
                  <img class="icon-pdf" src="../../assets/img/draft.png"/>
                  {{ item.title }}
                </div>
              </template>
              <template v-else-if="activeName === 'mindmap'">
                <div class="item-title" v-for="(item, index) in list" :key="`mindmap-${item.mind_map_id || item.id || index}`" @click="toMindmap(item.mind_map_id || item.id)">
                  <img class="icon-pdf" src="https://bookor-formal.oss-cn-beijing.aliyuncs.com/mind.png"/>
                  {{ item.title || item.content || '调试：无标题' }}
                  <span v-if="!item.title && !item.content" style="color: red; font-size: 12px;">[调试: {{ JSON.stringify(item) }}]</span>
                </div>
              </template>
              <template v-else-if="activeName === 'timeline'">
                <div class="item-title" v-for="(item, index) in list" :key="`timeline-${item.id || index}`" @click="toTimeline(item.id)">
                  <img class="icon-pdf" src="../../assets/img/note.png"/>
                  {{ item.title }}
                </div>
              </template>
            </div>
          </div>
        </el-drawer>
        <div class="restart-search">
          <el-tooltip class="item" effect="dark" content="文章收录" placement="top">
              <i class="el-icon-monitor" @click="articleCollect"></i>
          </el-tooltip>
          <el-tooltip trigger="hover" popper-class="menu-tooltip"  placement="top">
              <ul slot="content" class="menu-list">
                  <li @click="addMindVisible = true">新建脑图</li>
                  <li @click="addNote">新建笔记</li>
                  <li click="addDraft" @click="addDraft">新建白板</li>
                  <li @click="addTimeline">新建时间轴</li>
              </ul>
              <i class="el-icon-document-add"/>
          </el-tooltip>
          <el-tooltip effect="dark" content="论文矩阵">
            <img src="https://bookor-formal.oss-cn-beijing.aliyuncs.com/aaavvv.png" @click="toAtom"/>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="查看文档" placement="bottom">
            <img
            class="doc-switch"
            @click="handleRestartSearch"
            src="@/assets/editor/switchdoc.png"
            alt=""
          >
          </el-tooltip>
        <div>
      </div>
      </div>
      <el-dialog title="新增脑图" :visible.sync="addMindVisible" width="40%">
        <el-input v-model="mindTitle" placeholder="请输入脑图名称" maxlength="20" show-word-limit clearable />
        <span slot="footer" class="dialog-footer">
          <el-button @click="addMindVisible = false">取 消</el-button>
          <el-button type="primary" @click="addMindMap">确 定</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
import axios from '@/http';
import request from '@/http/request';
import List from './list.vue';
import { convertList, getSearchContent, searchEmu } from './util';
import { EventBus } from '@/main.js';

export default {
  data () {
    return {
      addMindVisible: false,
      mindTitle: '',
      loading: false,
      drawer: false,
      showType: 0,  // 0 展示默认列表，1，展示搜索
      searchType: 0, // 搜索类型0，关键词，1，词条
      tagList: [], // 词条列表
      activeTag: '', // 选中的词条
      activeName: searchEmu.PAPER,
      searchConfig: [
        {
          label: '本地',
          name: searchEmu.PAPER
        },
        {
          label: '脑图',
          name: searchEmu.MINDMAP
        },
        {
          label: '论文',
          name: searchEmu.THESIS
        },
        {
          label: '文章',
          name: searchEmu.ARTICLE
        },
        {
          label: '书评',
          name: searchEmu.BOOK_COMMENT
        },
        {
          label: '笔记',
          name: searchEmu.NOTE
        },
        {
          label: '白板',
          name: searchEmu.DRAFT
        },
        {
          label: '时间轴',
          name: searchEmu.TIMELINE
        }
      ],
      activeNames: '',
      direction: 'ltr',
      type: searchEmu.PAPER, // 当前tabName
      contentObj: {},
      list: [],
      totalList: [],
      keyword: '',
      shareList: [], // 好友分享列表
      shareTotal: 0, // 好友分享总数
      sharePage: 1, // 好友分享分页
      searchPage: 1, // 搜索分页
      hasMore: true // 是否还有更多搜索结果
    }
  },
  props: ['searchDrawer', 'searchKeyword', 'searchList', 'searchTotal'],
  components: {
    List
  },
  watch: {
    searchDrawer (val) {
      this.drawer = val
    },
    searchKeyword (val) {
      this.keyword = val
      if(val) {
        this.showType = 1
        this.handleTabClick()
      }
    },
          keyword() {
        if(!this.keyword) {
          this.searchPage = 1
          this.hasMore = true
          this.handleTabClick()
        }
      },
    searchList () {
      // this.updateTotal(this.searchTotal)
      this.activeName = searchEmu.PAPER
      this.list = convertList({
        paper_list: {
          list: this.searchList
        }
      }, searchEmu.PAPER)
    }
  },
  methods: {
    addMindMap() {
      if(!this.mindTitle) {
        this.$message.error('请输入脑图名称')
        return
      }
      const userInfo = JSON.parse(localStorage.getItem('userinfo'))
      this.addMindVisible = false
      axios.post('/ai/mind/add', {
          title: this.mindTitle,
          memberId: userInfo.userid
      }).then(res => {
        if(res.code === 200) {
          this.$message.success('添加成功')
          window.open(`#/mind/${res.data}`, '_blank');
        } else {
          this.$message.error('添加失败')
        }
      })
    },
    openUrl(data) {
      // 本地文档
      if(this.activeName === searchEmu.PAPER) {
        this.$emit('getUrlData', {
          ...data,
          type: 'note',
          url: data.paper_url
        })
      } else {
        this.$emit('getUrlData',data)
      }
    },
    toAtom() {
      this.$router.push('/papermatrix')
    },
    addNote() {
      this.$router.push({
          name: 'note',
          query: {
            paperId: ''
          }
        })
    },
    addDraft() {
      this.$router.push({
        name: 'draft',
        query: {
          id: ''
        }
      })
    },
    addTimeline() {
      this.$router.push({
        name: 'Timeline'
      })
    },
    articleCollect() {
      this.$emit('openArticleCollect')
    },
    handleRestartSearch () {
      this.drawer = true
      this.$emit('updateSearchDrawer', true)
    },
    updateCatTotal (searchTotal) {
      const paperTotal = searchTotal?.paper_count || 0  // 本地
      const mindmapTotal = searchTotal?.mindmap_count || 0 // 脑图
      const thesisTotal = searchTotal.thesis_count || 0 // 论文
      const articleTotal = searchTotal?.article_count || 0 // 文章
      const commentTotal = searchTotal?.comment_count || 0 // 评论
      const noteTotal = searchTotal?.note_count || 0  // 笔记
      const draftTotal = searchTotal?.draft_count || 0 // 白板
      const timelineTotal = searchTotal?.timeline_count || 0 // 时间轴
      this.totalList = [paperTotal, mindmapTotal, thesisTotal, articleTotal, commentTotal, noteTotal, draftTotal, timelineTotal]
    },
    getCatTotal(id) {
      return new Promise((resolve, reject) => {
        let params ={}
        if(id) {
          params = {
            type: 2,
            cat_id: id,
          }
        }
        const authorization = localStorage.getItem('authorization')
        if (authorization) {
          request('/api/Paper/searchContentByTypeTotal', params).then((result) => {
            resolve(result)
          }).catch((error) => {
            reject(error)
          })
        } else {
          reject(new Error('No authorization'))
        }
      })
    },

    getTotal (keyword) {
      return new Promise((resolve, reject) => {
        request('/api/Paper/searchContentByTypeTotal', {
          type: 1,
          query: keyword,
        }).then((result) => {
          resolve(result)
        })
      })
    },
    searchCatList(isLoadMore = false) {
      request('api/Paper/searchContentByCatId', {
        cat_id: this.activeTag,
        page: this.searchPage,
        limit: 20,
        search_type: this.activeName
      }).then((res) => {
        this.loading = false
        const newList = convertList(res, this.activeName)
        
        if (isLoadMore) {
          this.list = [...this.list, ...newList]
        } else {
          this.list = newList
        }
        
        // 检查是否还有更多数据
        if (newList.length < 20) {
          this.hasMore = false
        } else {
          this.hasMore = true
        }
        
        // 为下次加载准备页码
        this.searchPage += 1
        
      }).catch(() => {
        this.loading = false
        if (!isLoadMore) {
          this.list = []
        }
      })
    },
    searchCat() {
      if(this.searchType) {
        // getClassifyList接口已移除
        this.tagList = []
        this.loading = false
      }
    },
    async handleTagClick(item) {
      this.activeTag = item.classify_id
      this.showType = 1
      this.searchPage = 1
      this.hasMore = true
      const total = await this.getCatTotal(this.activeTag)
      this.updateCatTotal(total)
      this.searchCatList()
    },
    typeChange() {
      if(this.searchType) {
        // getClassifyList接口已移除
        this.tagList = []
      }
      this.handleTabClick()
    },
    async getFriendShareTotal() {
      try {
        const res = await request('/api/wechatarticle/getSumUpShareList', {
          page: 1,
          limit: 1, // We only need the total, so limit can be 1
          is_self: "friend"
        }, 'post');
        return res.total || 0;
      } catch (error) {
        return 0;
      }
    },
    async handleTabClick () {
      if(!this.keyword) {
        this.showType = 0
        this.getCatTotal('').then(this.updateCatTotal);
        return
      }
      this.showType = 1;
      this.searchPage = 1
      this.hasMore = true
      this.loading = true
      if(this.searchType) {
       this.searchCat()
      } else {
        this.loadSearchContent()
      }
    },
    // 加载搜索内容
    async loadSearchContent(isLoadMore = false) {
      try {
        const result = await request('api/Paper/searchContent', {
          query: this.keyword,
          page: this.searchPage,
          limit: 20,
          search_type: this.activeName
        })
        
        this.loading = false
        const newList = convertList(result, this.activeName)
        
        if (isLoadMore) {
          this.list = [...this.list, ...newList]
        } else {
          this.list = newList
          const total = await this.getTotal(this.keyword)
          this.updateCatTotal(total)
        }
        
        // 检查是否还有更多数据
        if (newList.length < 20) {
          this.hasMore = false
        } else {
          this.hasMore = true
        }
        
        // 为下次加载准备页码
        this.searchPage += 1
        
      } catch (err) {
        this.loading = false
        if (!isLoadMore) {
          this.list = []
        }
        this.$message.error(err.message)
      }
    },
    // 滚动加载更多
    loadMore() {
      if (this.hasMore && !this.loading) {
        this.loading = true
        if(this.searchType) {
          this.searchCatList(true)
        } else {
          this.loadSearchContent(true)
        }
      }
    },
    async searchContentDetail (id) {
      const current = this.list.find((item) => item.id === id)
      // 草稿
      if (!current.content_arr.length) {
        const arr = await getSearchContent(id, this.keyword, this.activeName)
        if(arr.length) {
          current.content_arr = arr
        } else {
          this.getParerInfo(current)
        }
      }
    },
    change (arr) {
      const id = arr[arr.length - 1]
      if (id) {
        this.searchContentDetail(id)
      }
    },
    toDraft(id) {
      this.$router.push({
        name: 'draft',
        query: {
          id
        }
      })
    },
    toMindmap(id) {
      // 打开脑图
      window.open(`#/mind/${id}`, '_blank')
    },
    toTimeline(id) {
      // 打开时间轴详情
      this.$router.push({
        name: 'Timeline',
        query: {
          id: id
        }
      })
    },

    handleClose () {
      this.$emit('updateSearchDrawer', false)
    },
    
    // 获取好友分享文章列表
    getFriendShareList() {
      return new Promise((resolve, reject) => {
        const params = {
          page: this.sharePage,
          limit: 20,
          is_self: "friend"
        };
        
        request('/api/wechatarticle/getSumUpShareList', params, 'post').then(res => {
          if (res && res.list && res.list.length > 0) {
            let list = res.list;
            // 处理sum_up内容
            for (let i = 0; i < list.length; i++) {
              let sum_up = list[i].sum_up || '';
              sum_up = sum_up.replaceAll("/[\r\n]/g", " ");
              sum_up = sum_up.replace(/&nbsp;/g, " ");
              sum_up = sum_up.replace("hasSetZeroLevel:true", "")
              sum_up = sum_up.replace(/\[p\d+\]/g, ''); //展示sum_up时,替换一下段落标识;
              // 标记为好友分享
              list[i].isShared = true;
              list[i].author = list[i].nickname || '匿名好友';
              list[i].share_time = new Date(list[i].add_time * 1000).toLocaleDateString();
              // 为好友分享文章设置正确的ID格式
              list[i].id = `share-${list[i].article_id}`;
            }
            
            this.shareList = list;
            this.shareTotal = res.total || list.length;
            resolve(list);
          } else {
            console.warn('好友分享API返回无数据或格式错误:', res);
            this.shareList = [];
            this.shareTotal = 0;
            resolve([]);
          }
        }).catch(error => {
          console.error('好友分享API请求失败:', error);
          this.shareList = [];
          this.shareTotal = 0;
          reject(error);
        });
      });
    },
    getParerInfo (item) {
      const { id, url, title, type } = item
      const dotIndex = url?.lastIndexOf('.')
      const extension = url?.slice(dotIndex + 1)
      if (type === 'draft') {
        this.$router.push({
          name: 'draft',
          query: {
            id
          }
        })
        return
      }
      if (type === 'article') {
        // 如果是好友分享的文章，直接打开原文链接
        if (item.isShared && item.url) {
          window.open(item.url, '_blank')
          return
        }
        this.$router.push({
          name: 'article',
          query: {
            id: id
          }
        })
        return
      }
      if (type === 'friendShare') {
        // 好友分享文章，打开原文链接
        if (url) {
          window.open(url, '_blank')
        } else {
          this.$message.warning('该分享文章暂无原文链接')
        }
        return
      }
      if (extension === 'pdf') {
        this.$router.push({
          name: 'pdf',
          query: {
            paperId: id,
            title: title,
            url,
            keyword: this.keyword
          }
        })
      } else if (extension === 'docx') {
        this.$router.push({
          name: 'docx',
          query: {
            paperId: id,
            title: title,
            url
          }
        })
      } else {
        this.$router.push({
          name: 'note',
          query: {
            paperId: id
          }
        })
      }
      const data = {
        id: id,
        url: url,
        type: '',
        title: title
      }
      this.$emit('getLocalUrlData', data)
    },
    handleCon (item) {
      if ([searchEmu.LOCAL, searchEmu.PAPER].includes(this.activeName)) {
        this.getParerInfo(item.id)
        return
      } else if (this.activeName === searchEmu.THESIS) {
        request('/api/Paper/getPaperInfo', {
          paper_id: id
        }).then((result) => {
          let url = ''
          if (result.paper_url.includes('https://oss.bookor.com.cn')) {
            url = result.paper_url
          } else {
            url = `https://oss.bookor.com.cn/${result.paper_url}`
          }
          this.$router.push({
            name: 'pdfEmbed',
            query: {
              url,
              id,
              title: item.title
            }
          })
        })
      }

      const { id } = item
      if (this.activeName === searchEmu.DRAFT) {
        this.$router.push({
          name: 'draft',
          query: {
            id
          }
        })
      } else if (this.activeName === searchEmu.ARTICLE) {
        // 如果是好友分享的文章，直接打开原文链接
        if (item.isShared && item.url) {
          window.open(item.url, '_blank')
          return
        }
        this.$router.push({
          name: 'article',
          query: {
            id: id
          }
        })
      } else if (this.activeName === searchEmu.BOOK_COMMENT) {
        this.$router.push({
          name: 'bookComment',
          query: {
            id
          }
        })
      } else if (this.activeName === searchEmu.NOTE) {
        this.$router.push({
          name: 'bookNote',
          query: {
            id
          }
        })
      }
    },
    formatStr (con) {
      const reg = new RegExp(this.keyword, 'g')
      const str = con?.replace(reg, (item) => {
        return `<span class='tag-keyword'>${item}</span>`
      })
      return str
    },
    async refreshTotal() {
      const total = await this.getCatTotal(this.activeTag || '')
      this.updateCatTotal(total)
    }
  },
  async mounted() {
    const total = await this.getCatTotal('')
    this.updateCatTotal(total)
    // 监听时间轴删除事件
    EventBus.$on('timeline-deleted', this.refreshTotal);
  },
  beforeDestroy() {
    // 移除事件监听
    EventBus.$off('timeline-deleted', this.refreshTotal);
  }
}
</script>
<style lang="scss" scoped>
.search-bar-container{
  position: relative;
}
.search-bar-container .restart-search{
  position: fixed;
  top: 48%;
  left: 4px;
  // background-color: #000;
  width: 70px;
  height: 40px;
  flex-wrap: wrap;
  display: flex;

  gap: 4px;
  i{
    font-size: 28px;
    cursor: pointer;
  }
  img{
    cursor: pointer;
    width: 30px;
    height: 30px;
  }
}
.more-content-tooltip{
  background-color: #999!important;
  .popper__arrow, .popper__arrow:after{
      border-top-color: #999!important;
  }
}
.more-content{
  width: 600px;
  font-size: 14px;
}
.search-bar-main{
  padding: 0 20px;
}
.search-bar-con{
  padding: 0 20px;
  .tag-keyword{
    background-color: rgb(248, 180, 33);
  }
  :deep(.el-collapse-item__header) {
    border-bottom: 1px solid #ddd;
  }
  :deep(.el-collapse-item__content) {
    padding-bottom: 0;
  }
  .empty{
    color: #999;
    text-align: center;
    padding: 40px 0;
  }
  .item-title{
    white-space: nowrap;
    cursor: pointer;
    overflow: hidden;
    padding: 0 10px;
    text-overflow: ellipsis; /* 显示省略号 */
    width: 350px;
    display: flex;
    align-items: center;
    min-height: 50px;
    
    // 好友分享文章的特殊样式
    &.friend-share-item {
      .title-content {
        display: flex;
        flex-direction: column;
        gap: 6px;
        
        .title-text {
          font-weight: 600;
          font-size: 14px;
          line-height: 1.4;
        }
        
        .friend-share-meta {
          display: flex;
          gap: 16px;
          font-size: 12px;
          opacity: 0.9;
          
          .share-author,
          .share-time {
            display: flex;
            align-items: center;
            gap: 4px;
          }
        }
      }
    }
    
    .title-content {
      flex: 1;
      
      .title-text {
        display: block;
      }
    }
  }
  
  .wechat-share-icon {
    /* 微信分享图标样式，保持默认样式 */
    filter: none;
  }
  .icon-pdf{
    width: 20px;
    height: 20px;
    position: relative;
    top: 5px;
    margin-right: 4px;
  }
  .item-text{
    height: 24px;
    cursor: pointer;
    white-space: nowrap; /* 不换行 */
    overflow: hidden; /* 内容超出部分隐藏 */
    text-overflow: ellipsis; /* 显示省略号 */
    margin-top: 5px;
    margin-left: 20px;
    position: relative;
    padding-left: 16px;
    &:before{
      content: '';
      display: block;
      width: 6px;
      height: 6px;
      background-color: #666;
      border-radius: 50%;
      position: absolute;
      top: 8px;
      left: 0px;
    }
  }
}
.editor-search-bar .el-input{
  // width: 80%;
  margin-bottom: 20px;
}
.search-con{
  width: 80%;
  margin-left: 10%;
  display: flex;
  gap: 8px;
}
.tags-list{
  width: 80%;
  display: flex;
  gap: 8px;
  margin-left: 10%;
  overflow-x: auto;
  .el-tag{
    cursor: pointer;
  }
  .active{
    background-color: #0003ff;
  }
  &::-webkit-scrollbar {
    height: 2px;
    background: transparent;
  }

  &::-webkit-scrollbar-button {
    display: none;
  }
}
.draft-list-con{
  background-color: #fff;
  border-radius: 6px;
  .item-title{
    white-space: nowrap;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis; /* 显示省略号 */
    height: 50px;
    padding-left: 10px;
    line-height: 50px;
    border-bottom: 1px solid #EBEEF5;
    width: auto;
  }
}
.menu-tooltip{
  padding: 0;
}
:deep(.menu-tooltip) {
  padding: 0!important;
}
.menu-list{
  li{
    height: 30px;
    line-height: 30px;
    padding: 5px 15px;
    border-radius: 4px;
    cursor: pointer;
    &:hover{
      background-color: #111;
    }
  }
}
</style>
